import { useContext } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import AppContext from "../../contexts/AppContext";

export default function LedgerItemDialog({ modalControl, dialogData, button }) {
  const { characters, raidTeams } = useContext(AppContext);
  const { open, setOpen, pending } = modalControl;
  const { title, dialogInfo } = dialogData;
  const characterId = dialogInfo.character_name ?? dialogInfo.character_id;
  const fields = {
    ID: dialogInfo.id,
    "Raid Team": raidTeams.find((team) => team.id === dialogInfo.raid_team)?.name ?? "",
    Character: characters.find((character) => character.id === characterId)?.name ?? "",
    Item: dialogInfo.item,
    "Item ID": dialogInfo.itemId,
    "DKP Amount": dialogInfo.dkp,
  };
  const close = () => { if (!pending) setOpen(false); };
  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {Object.entries(fields).map(([label, value]) => (
            <TextField key={label} label={label} value={value ?? ""} disabled />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={pending} onClick={close}>Cancel</Button>
        {button.actionButton()}
      </DialogActions>
    </Dialog>
  );
}
